import { render, staticRenderFns } from "./edit-marketing-staff.vue?vue&type=template&id=2343b56c&scoped=true&"
import script from "./edit-marketing-staff.vue?vue&type=script&lang=js&"
export * from "./edit-marketing-staff.vue?vue&type=script&lang=js&"
import style0 from "./edit-marketing-staff.vue?vue&type=style&index=0&id=2343b56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2343b56c",
  null
  
)

export default component.exports